import { render, staticRenderFns } from "./Relatorio.vue?vue&type=template&id=cf3b6f8c&scoped=true"
import script from "./Relatorio.vue?vue&type=script&lang=js"
export * from "./Relatorio.vue?vue&type=script&lang=js"
import style0 from "./Relatorio.vue?vue&type=style&index=0&id=cf3b6f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3b6f8c",
  null
  
)

export default component.exports